import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const WalkIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M13.5 5.90698C14.6 5.90698 15.5 5.02791 15.5 3.95349C15.5 2.87907 14.6 2 13.5 2C12.4 2 11.5 2.87907 11.5 3.95349C11.5 5.02791 12.4 5.90698 13.5 5.90698ZM9.8 9.22791L7.24 21.8377C7.11 22.4335 7.59 23 8.22 23H8.3C8.77 23 9.17 22.6874 9.28 22.2381L10.9 15.186L13 17.1395V22.0233C13 22.5605 13.45 23 14 23C14.55 23 15 22.5605 15 22.0233V16.5144C15 15.9772 14.78 15.4693 14.38 15.0981L12.9 13.7209L13.5 10.7907C14.57 12.0019 16.12 12.8712 17.86 13.1447C18.46 13.2326 19 12.7637 19 12.1679C19 11.6893 18.64 11.2888 18.15 11.2107C16.63 10.9665 15.37 10.0874 14.7 8.93488L13.7 7.37209C13.14 6.50279 12.02 6.15116 11.05 6.55163L7.22 8.13395C6.48 8.44651 6 9.14977 6 9.94093V12.2558C6 12.793 6.45 13.2326 7 13.2326C7.55 13.2326 8 12.793 8 12.2558V9.91163L9.8 9.22791Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

WalkIcon.propTypes = {
  sx: PropTypes.object,
};

export default WalkIcon;
